import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this._onOutsideClick = (e) => {
      if (!this.element.contains(e.target)) this.close()
    }
    this._onKeydown = (e) => {
      if (e.key === "Escape") this.close()
    }
    this._onOtherMenuOpen = (e) => {
      if (e.detail.controller !== this) this.close()
    }
    window.addEventListener("popup-menu:open", this._onOtherMenuOpen)
  }

  disconnect() {
    this._removeListeners()
    window.removeEventListener("popup-menu:open", this._onOtherMenuOpen)
  }

  toggle(event) {
    event.stopPropagation()
    this.menuTarget.classList.contains("hidden") ? this.open() : this.close()
  }

  open() {
    window.dispatchEvent(new CustomEvent("popup-menu:open", { detail: { controller: this } }))
    this.menuTarget.classList.remove("hidden")
    document.addEventListener("click", this._onOutsideClick)
    document.addEventListener("keydown", this._onKeydown)
  }

  close() {
    this.menuTarget.classList.add("hidden")
    this._removeListeners()
  }

  _removeListeners() {
    document.removeEventListener("click", this._onOutsideClick)
    document.removeEventListener("keydown", this._onKeydown)
  }
}
